import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { LocalStorageClass } from '../helpers/local-storage-helper';

@Injectable({
  providedIn: 'root',
})
export class LoginPageGuard {
  private readonly router = inject(Router);

  private static readonly WAITING_URL = '/login/waiting-for-approval';

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = LocalStorageClass.retrieveTokenFromStorage();

    if (token?.length) {
      this.router.navigate(['']).then(() => {
        window.location.reload();
      });

      return false;
    }

    // A registered user awaiting approval holds only a tempToken (no real
    // token). They must stay locked on the waiting page — out of the app and
    // off the rest of the auth flow — until approved or disapproved.
    const tempRegistrationToken = LocalStorageClass.getTempRegistrationToken();
    if (tempRegistrationToken?.length && !state.url.startsWith(LoginPageGuard.WAITING_URL)) {
      this.router.navigate([LoginPageGuard.WAITING_URL]);
      return false;
    }

    return true;
  }
}
